<div class="content-wrapper-inner">
  <h1 class="row-mb text-dashboard">Dashboard</h1>
  <app-clickterm-promo-banner class="d-block"></app-clickterm-promo-banner>
  <app-onboarding class="row-mb dashboard-onboarding"></app-onboarding>
  <div class="row-mb stat-widgets">
    <div *ngIf="summary; else loadingCounterContent" class="widget"
      [tooltip]="'This is the total number of outgoing test messages sent, including free back-up tests'" [tooltipPlacement]="'bottom'">
      <app-dashboard-counter-widget [title]="'Tests'" [val]="summary.tests"></app-dashboard-counter-widget>
    </div>
    <div *ngIf="summary; else loadingCounterContent" class="widget" [tooltip]="'The amount of suppliers set up that are available for this account'"
      [tooltipPlacement]="'bottom'">
      <app-dashboard-counter-widget [title]="'Suppliers'" [val]="summary.suppliers"></app-dashboard-counter-widget>
    </div>
    <div *ngIf="summary; else loadingCounterContent" class="widget" [tooltip]="'The amount of SMPP connections set up that are available for this account'"
      [tooltipPlacement]="'bottom'">
      <app-dashboard-counter-widget [title]="'Sessions'" [val]="summary.sessions"></app-dashboard-counter-widget>
    </div>
    <ng-template #loadingCounterContent>
      <div class="placeholder-glow">
        <div class="placeholder counter w-100"></div>
      </div>
    </ng-template>
  </div>
  <div class="row-mb">
    <div class="controls-panel">
      <div class="title">
        <h2>Overview</h2>
      </div>
      <div class="controls">
        <!-- <div class="dates-range-label text-muted" *ngIf="rangeLabel">{{ rangeLabel }}</div> -->
        <div class="users-filter" *ngIf="user?.role === Role.ADMIN">
          <button *ngIf="selectedUsers?.length === 0; else userWithDeleteSection" class="d-flex justify-content-center align-items-center"
            (click)="openUserFilter()">
            Users <span class="icon-filter-1 ms-0_5"></span>
          </button>
          <ng-template #userWithDeleteSection>
            <div class="d-flex justify-content-center align-items-center user-filter-with-delete">
              <button class="d-flex justify-content-center align-items-center active" (click)="openUserFilter()">
                Users ({{selectedUsers?.length}})
              </button>
              <span (click)="onClearAllUsersFilter()" class="far fa-trash-alt active"></span>
            </div>
          </ng-template>
        </div>

        <div *ngIf="rangeStart && rangeEnd" class="dates-range-control">
          <input-search-period (change)="onChangeDatesRange($event)" [placeholder]="'Date'" [ranges]="ranges" [start]="rangeStart" [end]="rangeEnd"
            [autoApply]="false" [minDate]="minDate" [maxDate]="maxDate"></input-search-period>
        </div>
        <button *ngIf="showProfit" class="btn btn-primary btn-profit" (click)="profitWidget.onClickButtonOpenProfitDetail()">Profit details</button>
      </div>
    </div>
  </div>
  <div *ngIf="showProfit" class="row-mb graph" @slideInFadeIn>
    <app-dashboard-profit-widget [users]="selectedUsers" [from]="from" [to]="to"></app-dashboard-profit-widget>
  </div>

  <div *ngIf="showTests; else loadingContent" class="row-mb graph" @slideInFadeIn>
    <app-dashboard-test-count-widget [users]="selectedUsers" [from]="from" [to]="to"></app-dashboard-test-count-widget>
  </div>

  <div *ngIf="showUsers; else adminLoadingContent" class="row-mb graph">
    <app-dashboard-test-count-user-widget [users]="selectedUsers" [from]="from" [to]="to"></app-dashboard-test-count-user-widget>
  </div>

  <div *ngIf="showServices; else loadingContent" class="row-mb graph" @slideInFadeIn>
    <app-dashboard-test-count-service-widget [users]="selectedUsers" [from]="from" [to]="to"></app-dashboard-test-count-service-widget>
  </div>

  <div *ngIf="showWorld; else loadingContent" class="row-mb graph" @slideInFadeIn>
    <app-dashboard-test-count-world-widget [users]="selectedUsers" [from]="from" [to]="to"></app-dashboard-test-count-world-widget>
  </div>

  <!-- ng-template for general loading content -->
  <ng-template #loadingContent>
    <div class="placeholder-glow">
      <div class="placeholder w-100"></div>
    </div>
  </ng-template>

  <!-- ng-template for admin-specific loading content -->
  <ng-template #adminLoadingContent>
    <ng-container *ngIf="user?.role !== Role.ADMIN; else emptyTemplate">
      <div class="placeholder-glow">
        <div class="placeholder w-100"></div>
      </div>
    </ng-container>
  </ng-template>

  <!-- Empty template for admins (to show nothing) -->
  <ng-template #emptyTemplate></ng-template>
</div>


<ng-template #userFilterModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Users</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body pb-20">
    <app-dashboard-user-filter [from]="from" [to]="to" [selectedUsers]="selectedUsers" (changeBatch)="selectedUsers = $event"></app-dashboard-user-filter>
  </div>
</ng-template>
